import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    signUpError: null,
    signInError: null,
    authError: null,
    searchMatchesError: null,
    supportEmailError: null
}

const slice = createSlice({
  name: 'errorObserver',
  initialState,
  reducers: {
    setSignUpError: (state, { payload }) => {
      return {...state, signUpError: payload}
    },
    setSignInError: (state, { payload }) => {
        return {...state, signInError: payload}
    },
    setAuthError: (state, { payload }) => {
        return {...state, authError: payload}
    },
    setSearchMatchesError: (state, { payload }) => {
        return {...state, searchMatchesError: payload}
    },
    setSupportEmailError: (state, { payload }) => {
      return {...state, supportEmailError: payload}
    }
  },
})

const { reducer, actions } = slice

export const { setSignUpError, setSignInError, setAuthError, setSearchMatchesError, setSupportEmailError } = actions

export default reducer